import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function Instituition() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [schools, setSchools] = useState([]);

  useEffect(() => {
    CommonService.getAllSchools().then((data) => setSchools(data));
  }, []);

  return (
    <fieldset>
      <legend>{t("Institution")}</legend>{" "}
      <select
        className="form-select"
        name="InstitutionId"
        onChange={onChange}
        value={searchObject.InstitutionId || ""}
      >
        <option value=""></option>
        {schools.map((school) => (
          <option key={school.id} value={school.description}>
            {t(school.description)}
          </option>
        ))}
      </select>
    </fieldset>
  );
}
